import { API_BASE, api } from "../utils/api";

export const SALES_AUTH_TOKEN_KEY = "SALES_AUTH_TOKEN";
export const SALES_AUTH_USER_KEY = "SALES_AUTH_USER";
export const SALES_AUTH_ROLE_KEY = "SALES_AUTH_ROLE";

const parseResponse = async (responseOrPromise) => {
  const response = await responseOrPromise;
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || data?.message || `Request failed with status ${response.status}`);
  }
  return data;
};



const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const salesApi = (endpoint, options = {}) => {
  const token = localStorage.getItem(SALES_AUTH_TOKEN_KEY);

  return fetch(`${API_BASE}${endpoint}`, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
    ...options,
  });
};

export const setSalesSession = ({ access_token, sales_user }) => {
  if (access_token) {
    localStorage.setItem(SALES_AUTH_TOKEN_KEY, access_token);
  }
  if (sales_user) {
    localStorage.setItem(SALES_AUTH_USER_KEY, JSON.stringify(sales_user));
  }
  localStorage.setItem(SALES_AUTH_ROLE_KEY, "sales_team");
};

export const setSalesUser = (salesUser) => {
  if (salesUser) {
    localStorage.setItem(SALES_AUTH_USER_KEY, JSON.stringify(salesUser));
  }
};

export const clearSalesSession = () => {
  localStorage.removeItem(SALES_AUTH_TOKEN_KEY);
  localStorage.removeItem(SALES_AUTH_USER_KEY);
  localStorage.removeItem(SALES_AUTH_ROLE_KEY);
};

export const getSalesAuthToken = () => localStorage.getItem(SALES_AUTH_TOKEN_KEY);

export const getStoredSalesUser = () => {
  try {
    const raw = localStorage.getItem(SALES_AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const createSalesUser = async (payload) => parseResponse(api("/sales-team/users", {
  method: "POST",
  body: JSON.stringify(payload),
}));

export const getSalesUsers = async (params) => parseResponse(api(`/sales-team/users${buildQuery(params)}`));

export const updateSalesUser = async (id, payload) => parseResponse(api(`/sales-team/users/${id}`, {
  method: "PATCH",
  body: JSON.stringify(payload),
}));

export const getSalesAdminDashboard = async () => parseResponse(api("/sales-team/dashboard"));

export const getSalesSharedLinks = async () => parseResponse(api("/sales-team/shared-links"));

export const getSalesRequestUsers = async (params) => parseResponse(api(`/sales-team/request-users${buildQuery(params)}`));

export const salesLogin = async (payload) => parseResponse(fetch(`${API_BASE}/sales-team/auth/login`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
}));

export const getSalesSession = async () => parseResponse(salesApi("/sales-team/auth/session"));

export const getSalesUserDashboard = async () => parseResponse(salesApi("/sales-team/me/dashboard"));

export const createSalesSharedLink = async () => parseResponse(salesApi("/sales-team/me/shared-links", {
  method: "POST",
}));